// extracted by mini-css-extract-plugin
export default {"section":"SectionContent_section__rQluj","content":"SectionContent_content__+AksY"};